import React from "react";
import { connect } from 'react-redux';
import MUIDataTable from "mui-datatables";
import lodash from 'lodash';

// @material-ui/core components
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import MTablestyles from "assets/jss/material-dashboard-pro-react/customMTableStyle.jsx";

// core components
import TableActionButton from "components/CustomToolbar/TableActionButton.jsx"
import CustomSweetAlert from "components/SweetAlert/CustomSweetAlert.jsx";
import TableLoaderSpinner from 'components/Table/TableLoaderSpinner'

// import Badge from "components/Badge/Badge.jsx";

import { winnerApproveActions } from 'actions';
import { plugins, loader, crmValidator, alert as customAlert } from 'helpers';
import { winnerApproveConstants } from '../../constants';
import { winnerApproveServices } from 'services';

const style = {
    customCardContentClass: {
        paddingLeft: "0",
        paddingRight: "0"
    },
    cardIconTitle: {
        ...cardTitle,
        marginTop: "15px",
        marginBottom: "0px"
    },
    actionDiv: {
        display: "inline-flex"
    }
};

const pageStyle = { ...style };

const THEME = createMuiTheme({
    ...MTablestyles,
    overrides: {
        ...MTablestyles.overrides,
        MuiTableCell: {
            head: {
                "&:nth-child(11)": {
                    textAlign: "right"
                }
            },
            body: {
                "&:nth-child(22)": {
                    textAlign: "right"
                }
            }
        }
    }
});

class TableWinnerApproveList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            readOnly: true,
            page: 0,
            rowsPerPage: 10,
            count: 100,
            data: [],
            reqParams: "",
            filter: {
                skip: 0,
                limit: 10,
                sortBy: "created_at",
                sortDir: "desc",
                keyword: ""
            }
        };

        this.delayedCallback = lodash.debounce(this.getData, 500)
    }

    getData = (skip, limit, sortBy, sortDir, keyword) => {
        const { dispatch, tableReload, tableFilter } = this.props
        // if (this.state.refreshTable) {
        //     tableFilter.skip = null
        //     tableFilter.sortBy = "createdAt"
        //     tableFilter.sortDir = "desc"
        //     tableFilter.keyword = ""
        //     tableFilter.search = {}
        //     this.setState({
        //         refreshTable: false
        //     })
        // }

        let reqParams = tableFilter;

        if (!tableReload) {
            if (crmValidator.isEmptyValue(skip)) {
                reqParams.skip = 0
            }

            if (crmValidator.isEmptyValue(limit)) {
                reqParams.limit = 10
            }
            reqParams.page = skip;
            this.setState({
                rowsPerPage: limit
            })
            skip = parseInt(limit) * parseInt(skip)

            reqParams.skip = skip;
            reqParams.limit = limit;

            if (!crmValidator.isEmptyValue(sortBy)) {
                reqParams.sortBy = sortBy;
            }

            if (!crmValidator.isEmptyValue(sortDir)) {
                reqParams.sortDir = sortDir;
            }

            if (!crmValidator.isEmptyValue(keyword)) {
                reqParams.keyword = keyword;
            } else {
                reqParams.keyword = ""
            }
        } else {
            reqParams = tableFilter

        }
        dispatch(winnerApproveActions.getTableDatas(reqParams));
        this.setState({
            isLoading: true,
            reqParams: reqParams
        });
    }

    componentWillMount() {
        const { dispatch } = this.props;
        dispatch({ type: winnerApproveConstants.CLEAR_PAGE_STATE });
    }

    componentDidUpdate() {
        const { tableReload, tableReset, dispatch, tableFilter } = this.props;
        if (tableReload || tableReset) {
            this.getData();
            dispatch({ type: winnerApproveConstants.TABLE_RELOAD_SUCCESS })
        }
    }

    getRowData(rowIndex = 0) {
        const { tableDatas } = this.props;
        const data = tableDatas;
        return data[rowIndex];
    }

    render() {
        const { classes, formInitialValue, tableDatas, tableKey, visiblePersonalData, showLoader, tableTotal, tableFilter } = this.props;
        const { rowsPerPage } = this.state;
        let columns = [
            { name: "_id", options: { filter: false, display: "excluded" } },
            {
                name: "order", label: "Order", options: {
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const rowData = this.getRowData(tableMeta.rowIndex)

                        //return (rowData.qr.key === undefined || rowData.qr.key === null ? "" : rowData.qr.key)
                        if (rowData.order !== undefined || rowData.order != null) {
                            return (rowData.order);
                        } else {
                            return "";
                        }
                    }
                }
            },
            {
                name: "period.announceDate", label: "Announce Date",
                options: {
                    filter: false,
                    customBodyRender: (value, tableMeta) => {
                        const rowIndex = tableMeta.rowIndex;
                        const rowData = this.getRowData(rowIndex);
                        return (rowData.period.announceDate ? plugins.datetimeFormat(rowData.period.announceDate, "fulldatetime") : "");
                    }
                }

            },
            { name: "mobileNo", label: "Mobile No." },
            { name: "code", label: "Code" },
            { name: "display", label: "Display" },
            { name: "winnerType", label: "Winner Type" },
            { name: "status", label: "Status" },
            {
                name: "created_at", label: "Create Date"
                ,
                options: {
                    filter: false,
                    customBodyRender: (value, tableMeta) => {
                        const rowIndex = tableMeta.rowIndex;
                        const rowData = this.getRowData(rowIndex);
                        return (rowData.created_at ? plugins.datetimeFormat(rowData.created_at, "fulldatetime") : "");
                    }
                }
            },
        ];

        let options = {
            serverSide: true,
            count: (tableTotal ? tableTotal : 0),
            page: tableFilter.page ? tableFilter.page : 0,
            rowsPerPage: rowsPerPage,
            selectableRows: "none",
            print: false,
            download: false,
            filter: false,
            responsive: "scroll",
            rowsPerPageOptions: [5, 10, 20],
            onTableChange: (action, tableState) => {
                let skip, limit, sortBy, sortDir, keyword = ""

                if (tableState.page !== null) {
                    skip = tableState.page
                }

                if (tableState.rowsPerPage !== null) {
                    limit = tableState.rowsPerPage
                }

                if (tableState.activeColumn !== null) {
                    sortBy = tableState.columns[tableState.activeColumn].name
                }
                if (tableState.announceText !== null) {
                    sortDir = tableState.announceText.search("descending") !== -1 ? "desc" : "asc"
                }
                if (tableState.searchText !== null || action === 'search') {
                    keyword = tableState.searchText
                    this.delayedCallback(skip, limit, sortBy, sortDir, keyword)
                }
                let actionList = ['changePage', 'sort', 'changeRowsPerPage']
                if (actionList.indexOf(action) !== -1) {
                    this.getData(skip, limit, sortBy, sortDir, keyword)
                }
            },
        };

        return (
            <div id="tableWinnerApproveList">
                <CustomSweetAlert />
                <MuiThemeProvider theme={THEME}>
                    <MUIDataTable
                        key={tableKey}
                        data={tableDatas}
                        columns={columns}
                        options={options}
                    />
                    {showLoader && <TableLoaderSpinner />}

                </MuiThemeProvider>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { formInitialValue, tableReload, tableReset, tableDatas, tableKey, showLoader, tableTotal, tableFilter } = state.winner_approve;
    const { visiblePersonalData, merchantSetting } = state.authentication;

    return {
        formInitialValue, tableReload, tableReset, visiblePersonalData, tableDatas, tableKey, showLoader, merchantSetting, tableTotal, tableFilter
    };
}
export default connect(mapStateToProps)(withStyles(pageStyle)(TableWinnerApproveList));  